/**
 * delivery-date.js
 */

document.addEventListener('DOMContentLoaded', () => {
  initDeliveryDate();
});

function initDeliveryDate() {
  const elements = document.querySelectorAll('.js-delivery-date-calculator');
  if (elements.length === 0) return;

  elements.forEach(container => {
    const cutoffHour = parseInt(container.dataset.cutoffHour, 10) || 10;
    const prefixText = container.dataset.prefix || "発送予定日：";
    
    // 休業日リスト
    let specialHolidays = [];
    try {
      if (container.dataset.holidays) {
        specialHolidays = JSON.parse(container.dataset.holidays);
      }
    } catch (e) {
      console.error('特定休業日データのパースに失敗しました', e);
    }
    // 計算実行
    const dateRange = calculateShippingRange(cutoffHour, specialHolidays);
    // 表示更新
    if (dateRange) {
      container.querySelector('.custom-date-text').textContent =
        `${prefixText} ${dateRange.minStr}〜${dateRange.maxStr}`;
    }
  });
}

function calculateShippingRange(cutoffHour, specialHolidays) {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const currentHour = now.getHours();

  // 締め切り時間を過ぎているかどうか
  const isAfterCutoff = currentHour >= cutoffHour;
  // 曜日ごとの加算日数定義
  const SHIPPING_CYCLE = {
    1: { // 月曜
      before: [1, 3],
      after:  [2, 3]
    },
    2: { // 火曜
      before: [1, 3],
      after:  [2, 3]
    },
    3: { // 水曜
      before: [1, 3],
      after:  [2, 3]
    },
    4: { // 木曜
      before: [1, 4],
      after:  [2, 4]
    },
    5: { // 金曜
      before: [1, 4],
      after:  [2, 4]
    },
    6: { //土曜
      before: [1, 4],
      after:  [3, 4]
    },
    0: { //日曜
      before: [2, 3],
      after:  [2, 3]
    }
  };
  
  const logic = SHIPPING_CYCLE[dayOfWeek];
  const addDaysArray = isAfterCutoff ? logic.after : logic.before; // [最短営業日, 最長営業日]
  const minDate = addBusinessDays(now, addDaysArray[0], specialHolidays);
  const maxDate = addBusinessDays(now, addDaysArray[1], specialHolidays);

  return {
    minStr: formatDateJP(minDate),
    maxStr: formatDateJP(maxDate)
  };
}

function addBusinessDays(baseDate, businessDaysToAdd, holidays) {
  let date = new Date(baseDate);
  let addedDays = 0;
  while (addedDays < businessDaysToAdd) {
    date.setDate(date.getDate() + 1);
    // その日が休業日でなければ、営業日としてカウント
    if (!isHoliday(date, holidays)) {
      addedDays++;
    }
    // 休業日ならカウントせず、次のループでさらに1日進む
  }
  while (isHoliday(date, holidays)) {
    date.setDate(date.getDate() + 1);
  }
  
  return date;
}
function isHoliday(dateObj, holidaysList) {
  if (!holidaysList || holidaysList.length === 0) return false;
  
  const year = dateObj.getFullYear();
  const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
  const day = ('0' + dateObj.getDate()).slice(-2);
  const dateStr = `${year}-${month}-${day}`;
  
  return holidaysList.includes(dateStr);
}
function formatDateJP(dateObj) {
  const weekDaysJP = ["日", "月", "火", "水", "木", "金", "土"];
  const m = dateObj.getMonth() + 1;
  const d = dateObj.getDate();
  const w = weekDaysJP[dateObj.getDay()];
  
  return `${m}月${d}日(${w})`;
}